import { render, staticRenderFns } from "./hyl.vue?vue&type=template&id=2d182064&scoped=true&"
import script from "./hyl.vue?vue&type=script&lang=js&"
export * from "./hyl.vue?vue&type=script&lang=js&"
import style0 from "./hyl.vue?vue&type=style&index=0&id=2d182064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d182064",
  null
  
)

export default component.exports